export function normalize(text: string): string {
  if (!text) { return text; }
  return text?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
